import { render, staticRenderFns } from "./EditAttendancePoint.vue?vue&type=template&id=664d88c6&scoped=true"
import script from "./EditAttendancePoint.vue?vue&type=script&lang=js"
export * from "./EditAttendancePoint.vue?vue&type=script&lang=js"
import style0 from "./EditAttendancePoint.vue?vue&type=style&index=0&id=664d88c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664d88c6",
  null
  
)

export default component.exports